import { TReduxActions } from '../../../types/redux';
import { EEcologyRatingActionTypes } from '../../../actions/newReview';
import { TEcologyRating } from '../../../types/newReview';
import { ENewReviewForm } from '../../../actions/newReview/newReviewsAction';

export const defaultValue = {
  value: 0,
};

export function ecologyRatingReducer(
  state: TEcologyRating = defaultValue,
  { type, payload }: TReduxActions,
): TEcologyRating {
  if (type === EEcologyRatingActionTypes.SetRating) {
    return {
      value: payload,
    };
  }

  if (type === ENewReviewForm.Clear) {
    return defaultValue;
  }

  return state;
}
